// extracted by mini-css-extract-plugin
export default {"subtitleCategories":"dN7_GnOJTh"};